import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import MaterialIcon from "material-icons-react";
import i18n from '../../../../i18next';

class DeliveryZoneConfirmationScreen extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.manageSettingsData = this.manageSettingsData.bind(this);
    }

    toggle(cancelClicked) {
        this.props.onToggle(cancelClicked);
    }

    manageSettingsData(saveZoneType) {
        this.props.onSave(this.props.deliveryZone.id);
        this.props.onToggle();
    }

    renderSaveBtn() {
        return (
            <Button color="primary" onClick={() => {this.manageSettingsData(true)}}>
                <MaterialIcon icon="done" color="#fff" size={18} /> {i18n.t('common:buttons.confirm')}
            </Button>
        );
    }

    render() {
        const cancelClicked = true;
        return (
            <div>
                <Modal isOpen={this.props.isOpen} toggle={() => this.toggle(cancelClicked)}>
                    <ModalHeader className="modalHeader" toggle={() => this.toggle(cancelClicked)}>{this.props.message.header}</ModalHeader>
                    <ModalBody>
                        <p>{this.props.message.firstRow}<br />
                            {this.props.message.secondRow}</p>
                    </ModalBody>
                    <ModalFooter>
                        {this.renderSaveBtn()}
                        <Button outline color="primary" onClick={() => this.toggle(cancelClicked)}>{i18n.t('common:buttons.cancel')}</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default DeliveryZoneConfirmationScreen;





// WEBPACK FOOTER //
// ./src/components/restaurants/settings/service/DeliveryZoneConfirmationScreen.js